module.exports = __webpack_public_path__ + "img/31_14.44c531ae.png";